import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReferEarnService } from '@app/refer-and-earn/refer-earn.service';
import { AlertService } from '@service/alert.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-refer-transaction',
  templateUrl: './refer-transaction.component.html',
  styles: [
  ]
})
export class ReferTransactionComponent implements OnInit {

  isApp: boolean = false
  isLoading: boolean = false
  transactionDetail: any[] = []
  constructor(
    private dialagRef: MatDialogRef<ReferTransactionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertService: AlertService,
    private ReferEarnservice: ReferEarnService
  ) { }

  ngOnInit(): void {
    this.getTransaction()
    this.alertService.getIsMobileDevice().subscribe((res)=>this.isApp = res)
  }

  closeDialog() {
    this.dialagRef.close(false)
  }

  getTransaction(){
    this.isLoading = true
    this.ReferEarnservice.getTransactionDeatils(this.data.reward?.reference).pipe(finalize(()=>this.isLoading = false)).subscribe((res:any)=>{
      this.transactionDetail = res.data
    })
  }

}
